/**
 * Search
 */

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';
import Data from '@ifabnpm/bootstrap/dom/data.js';

import Drawer from '@ifabnpm/bootstrap/component/drawer.js';

// -------
// Privat
// -------

const NAME      = 'search';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY    = '.data-api';

let searchForm = null;
let searchField = null;
let searchFieldMin;

const setupSearchForm = (init = false) => {
	if (!init) {
		return;
	}

	const submitButton = SelectorEngine.findOne('button[type="submit"]', searchForm);

	searchFieldMin = parseInt(searchField.getAttribute('min') ?? 0, 10);

	// Formular-Submit prüfen.
	EventHandler.on(searchForm, 'submit', event => {
		if (Data.get(searchForm, 'searchEnabled') !== true) {
			event.preventDefault();
			event.stopPropagation();
		}
	});

	// Formular prüfen auf aktiv oder inaktiv.
	EventHandler.on(searchForm, 'search.handleSubmit', () => {
		if (searchField.value !== '' && searchField.value.length >= searchFieldMin) {
			Data.set(searchForm, 'searchEnabled', true);
			Manipulator.setDisabled(submitButton, false);
		} else {
			Data.set(searchForm, 'searchEnabled', false);
			Manipulator.setDisabled(submitButton);
		}
	});

	// Eingabefeld: bei Eingabe Formular prüfen
	EventHandler.on(searchField, 'keyup', () => {
		EventHandler.trigger(searchForm, 'search.handleSubmit');
	});

	// Eingabefeld: wenn per Klick ´geleert´, dann Formular prüfen
	EventHandler.on(searchField, 'clearable.clear', () => {
		EventHandler.trigger(searchForm, 'search.handleSubmit');
	});

	// Formular prüfen
	EventHandler.trigger(searchForm, 'search.handleSubmit');

	// Wenn wir uns auf der Suchseite befinden, muss der Seitentitel um den Suchbegriff erweitert werden.
	if (Manipulator.getDataAttribute(document.body, 'page-type') === 'search') {
		const pageTitleSubheader = SelectorEngine.findOne('.page-title .page-title__subheader') ?? null;

		if (pageTitleSubheader && searchField.value !== '') {
			pageTitleSubheader.dataset.searchQuery = searchField.value;
		}
	}
};

/**
 * Drawer ´Search´
 */
const setupDrawer = async (init = false) => {
	const ctrls = SelectorEngine.find('[aria-controls="search-drawer"]');

	let drawerApi;

	if (init) {
		const drawerContainer = SelectorEngine.findOne('#search-drawer');

		if (!drawerContainer) {
			for (const ctrl of ctrls) {
				Manipulator.setDisabled(ctrl, true);
			}

			return;
		}

		drawerApi = await new Drawer(drawerContainer, {
			closeButton: false,
			noHeader   : true,
			onShow     : function () {
				for (const ctrl of ctrls) {
					Manipulator.addClass(ctrl, '_active');
				}

				searchField.focus();
			},
			onHidden   : () => {
				for (const ctrl of ctrls) {
					Manipulator.removeClass(ctrl, '_active');
				}
			}
		});
	}

	for (const ctrl of ctrls) {
		if (init && drawerApi) {
			EventHandler.on(ctrl, `click${EVENT_KEY}`, (event) => {
				event.preventDefault();
				event.stopPropagation();

				if (event.delegateTarget.classList.contains('-active')) {
					drawerApi.hide();
				} else {
					// if (window.drawer.menu) {
					// 	window.drawer.next = drawerApi;
					// 	window.drawer.menu.hide();
					// } else {
					// 	drawerApi.show();
					// }

					drawerApi.show();
				}
			});
		} else {
			Manipulator.setDisabled(ctrl);
		}
	}
};

// -------
// Public
// -------

const search = async () => {
	searchForm  = SelectorEngine.findOne('.search-box form') ?? null;
	searchField = searchForm ? SelectorEngine.findOne('.search-box-input', searchForm) : null;

	await setupSearchForm(!!searchField);
	await setupDrawer(!!searchField);

	return searchForm;
};

// Export
export default search;
